import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AdditionalDocument } from '../../core/models/freight-document/AdditionalDocument';

@Component({
  selector: 'app-document-share',
  template: `
    <div class="d-flex flex-column align-items-center">
      <ng-container *ngIf="options.length > 1">
        <p class="text-center mb-2">{{ 'messenger.share.freightDocument.selectDocumentType' | transloco }}</p>
        <select class="form-select mb-3" [ngModel]="selectedOption" (ngModelChange)="selectOption($event)">
          <option *ngFor="let option of options" [ngValue]="option">
            {{ 'pdfTemplateType.' + option.pdfTemplateType | transloco }}
          </option>
        </select>
      </ng-container>

      <ng-container *ngIf="selectedOption">
        <p class="text-center mb-0">{{ 'messenger.share.freightDocument.shareInstruction' | transloco }}</p>
        <qrcode [qrdata]="selectedOption.viewPdfUrl" [width]="256" errorCorrectionLevel="M" elementType="url"></qrcode>

        <p class="text-center mt-3">{{ 'messenger.share.freightDocument.saveInstruction' | transloco }}</p>
        <div class="d-flex gap-3">
          <a [href]="selectedOption.viewPdfUrl" target="_blank" class="button-secondary" aria-label="Open">
            {{ 'action.open' | transloco }}
          </a>
          <button type="button" class="button-primary" aria-label="Download" (click)="download.emit(selectedOption)">
            {{ 'action.download' | transloco }}
          </button>
        </div>
      </ng-container>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentShareComponent implements OnChanges {
  @Input({ required: true }) options: AdditionalDocument[] = [];
  @Output() download = new EventEmitter<AdditionalDocument>();

  protected selectedOption: AdditionalDocument;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options) {
      this.selectOption(this.options?.[0]);
    }
  }

  selectOption(option: AdditionalDocument): void {
    this.selectedOption = option;
  }
}
